import { useEffect, useRef } from 'react';

/**
 * Hook used to check is a component si mounted or not
 * @returns {React.MutableRefObject<boolean>}
 */
const useIsMounted = () => {
  // USE REF HOOKS
  const isMounted = useRef(true);
  // USE EFFECT HOOKS
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

export default useIsMounted;
